module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限组名称",
      "prop": "power_name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-200",
    model: {
      value: (_vm.form.power_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "power_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.power_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限分配",
      "prop": "reason"
    }
  }, [_c('div', {
    staticClass: "bor-gray h-600 ovf-y-auto bor-ra-5 bg-wh"
  }, _vm._l((_vm.form.menu_list), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "p-l-20 bor-b-ccc"
    }, [_c('el-checkbox', {
      on: {
        "change": function($event) {
          return _vm.selectModuleRule(index)
        }
      },
      model: {
        value: (item.check),
        callback: function($$v) {
          _vm.$set(item, "check", $$v)
        },
        expression: "item.check"
      }
    }, [_vm._v(_vm._s(item.menu_name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "p-l-40 bor-b-ccc bg-gra"
    }, _vm._l((item.child), function(son_item) {
      return _c('el-checkbox', {
        on: {
          "change": function($event) {
            return _vm.selectActionRule(son_item.check, index)
          }
        },
        model: {
          value: (son_item.check),
          callback: function($$v) {
            _vm.$set(son_item, "check", $$v)
          },
          expression: "son_item.check"
        }
      }, [_vm._v(_vm._s(son_item.name))])
    }), 1)])
  }), 0)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5670f5f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/power/edit.vue
// module id = 1842
// module chunks = 2